module.exports = {"id":"241753","name":"Mohamed Amine Ben Amor","rating":"71","photo":"./data/images/photos/1/241753.png","club":{"name":"Al Ahli","logo":"./data/images/clubs/AlAhli.png"},"positions":["MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MohamedAmineBenAmor0.json
// module id = 3059
// module chunks = 0